import React, { useState } from 'react'
import * as microsoftTeams from '@microsoft/teams-js'

// This is the Task Module that is invoked from the `InsideIframe` component.
export const TestTaskModule = () => {
  const submitTask = () => microsoftTeams.dialog.url.submit(
    {
      task_name: 'test',
      foo: {
        bar: 'baz'
      }
    }
  )

  const [teamsContext, setTeamsContext] = useState({})

  useEffect(() => {
      // Initialize Microsoft Teams SDK on mount
      async function initTeamsSdk() {
        try {
          context = await microsoftTeams.app.getContext()
          setTeamsContext(context)
        } catch (err) {
          console.error("Error initializing Teams SDK", err)
        }
      }
      initTeamsSdk()
    }, [])

  return (
    <>
      <pre>{JSON.stringify(teamsContext, null, 2)}</pre>
      <p>{window.location.origin}</p>
      <button onClick={submitTask}>Submit</button>
    </>
  )
}
